export default "__VITE_ASSET__D3m_E$M6__"